import type { FC } from "react";

import { Checkbox } from "@recobra/ui/checkbox";
import { Field, FieldContent, FieldDescription, FieldLabel } from "@recobra/ui/field";

import { useFieldContext } from "./context";

export const CheckboxField: FC<{ label: string; id: string; hint?: string }> = ({
  label,
  id,
  hint,
}) => {
  const field = useFieldContext<boolean>();

  return (
    <Field orientation="horizontal">
      <Checkbox
        id={id}
        aria-describedby={hint ? `${id}-hint` : undefined}
        checked={field.state.value}
        onCheckedChange={(checked) => field.handleChange(checked === true)}
      />
      <FieldContent>
        <FieldLabel htmlFor={id}>{label}</FieldLabel>
        {hint && <FieldDescription id={`${id}-hint`}>{hint}</FieldDescription>}
      </FieldContent>
    </Field>
  );
};
